import { Component, Input } from '@angular/core';
import { TripAttraction, TripDay, TripPlan } from 'src/app/modules/shared/models/vititor.trip.storage.command';
import { TripPlannerService } from '../../../services/trip.planner.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CreateEditPlanComponent } from "../create.edit.plan/create.edit.plan.component";

@Component({
  selector: 'ig-trip-plan-list',
  standalone: true,
  imports: [CommonModule, MatIconModule, CreateEditPlanComponent],
  templateUrl: './trip.plan.list.component.html',
  styleUrl: './trip.plan.list.component.scss'
})
export class TripPlanListComponent {
  @Input() day: TripDay;
  @Input() attractionIndex = 0;
  @Input() planType: 'prePlans' | 'postPlans' = 'prePlans';
  @Input() isShowPlans = true;
  @Input() isEditMode = false;

  getPlanStyle(type: string) {
    const plan = TripPlannerService.planTypes.find(x => x.type === type);
    if (plan) {
      return plan;
    }

    return TripPlannerService.planTypes.find(x => x.type === 'Custom');
  }

  editPlan(planIndex: number, $event: TripPlan) {
    this.day.attractions[this.attractionIndex][this.planType][planIndex] = $event;
  }

  deletePlan(planIndex: number) {
    this.day.attractions[this.attractionIndex][this.planType].splice(planIndex, 1);
  }

  swapPlan(planIndex: number) {
    const upperOne = this.day.attractions[this.attractionIndex][this.planType][planIndex];
    this.day.attractions[this.attractionIndex][this.planType][planIndex] = this.day.attractions[this.attractionIndex][this.planType][planIndex + 1];
    this.day.attractions[this.attractionIndex][this.planType][planIndex + 1] = upperOne;
  }
}
